document.addEventListener('DOMContentLoaded', function() {

    const menuContainer = document.querySelector('.navigation');
    const menuToggle = menuContainer.querySelector('.menu-button');
    const siteNavigation = menuContainer.querySelector('#top-bar-nav-menu');

    if( menuToggle ) {
        menuToggle.setAttribute('aria-expanded', 'false');  
        siteNavigation?.setAttribute('aria-hidden', 'false');

        //Event Listener for main menu toggle button
        menuToggle.addEventListener('click', function(e) {
            e.preventDefault();
            this.classList.toggle('toggled-on');
            siteNavigation.classList.toggle('toggled-on');
            
            const expanded = this.getAttribute('aria-expanded') === 'true' || false;
            this.setAttribute('aria-expanded', !expanded);
            
            siteNavigation.setAttribute('aria-hidden', !expanded);

            //toggle #mobile-menu click open and close
            const mobileMenu = document.querySelector('#mobile-menu');
            mobileMenu.classList.toggle('mobile-menu--is-open');

        });

        //Event Listener for sub-menu toggle span
        const subMenuToggle = document.querySelectorAll('.carrot');
        subMenuToggle.forEach( function( toggle ) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                //alert('clicked');   
                this.parentElement.parentElement.classList.toggle('toggled-on'); //parent Li
                
             
            });
        });
        
    }
 
    const siteHeader = document.querySelector('.site-header');
    window.addEventListener('scroll', function() {
        if ( window.scrollY > 60 ) {
            siteHeader.classList.add('scrolled');
        } else {
            siteHeader.classList.remove('scrolled');
        }
    })

    //slide out submenu when carrot is clicked
    const subMenuCarrot = document.querySelectorAll('.carrot');
    subMenuCarrot.forEach( function( carrot ) {
        carrot.addEventListener('click', function(e) {
            e.preventDefault();
            
            const currentState = window.getComputedStyle(this.parentElement.parentElement.children[1]).right;
            if( currentState === '0px' ) {
                this.parentElement.parentElement.children[1].style.right = '-300px';   
            }else{
                this.parentElement.parentElement.children[1].style.right = '0px';
                this.parentElement.parentElement.children[1].style.width = '100%';
                this.parentElement.parentElement.children[1].style.top = '57px'; //height of mobile menu

            }
            //this.parentElement.parentElement.children[1].classList.toggle('toggled-on');
        });
    });

    const subMenuCarrot2 = document.querySelectorAll('.carrot-back');
    //go back to main menu
    subMenuCarrot2.forEach( function( carrot ) {
        carrot.addEventListener('click', function(e) {
            e.preventDefault();
            this.parentElement.parentElement.style.right = '-100%';
        });
    });

 


}); // DOMContentLoaded